import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService, PageMetaService, SharedService, User } from '@app/core';
import { HomeLayoutComponent } from '@app/layout';
import { BankingService } from '@app/modules/banking/services';
import { VoucherService } from '@app/modules/voucher/services';
import { PmdSidebar } from '@shared/propeller';
import _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SideBarSection } from '../sidebar/sidebar.section';


@Component({
  selector: 'app-sidebar-submenu',
  templateUrl: './sidebar-submenu.component.html',
  styleUrls: ['./sidebar-submenu.component.scss']
})
export class SidebarSubmenuComponent implements OnInit {
  @ViewChild(PmdSidebar) leftSidebar: { toggleSideBar: () => void; };
  @Input() isProfileOpen: boolean = false;
  url$: Observable<string> = new Observable<string>();
  currentURL: string;
  loggedinUser: User;
  menu: any;
  productTagsSubscription: Subscription;
  companyDetailsSubscription: Subscription;
  isLeadAdminModuleAccess: boolean = false;
  token: string;
  @ViewChild(HomeLayoutComponent) homeLayoutComponent!: HomeLayoutComponent;
  sideBarSection: SideBarSection;
  userRoles: any = {};
  featureToggles: any = {};
  showPushToPetpooja: boolean = false;
  showPushToRetailPos: boolean = false;
  showPushToTally: boolean = false;
  canShowBeneficiary = false;
  currentKYCStatus: any;

  constructor(
    public appGlobals: AppGlobals,
    public authService: AuthService,
    readonly pageMetaService: PageMetaService,
    private readonly router: Router,
    private readonly voucherService: VoucherService,
    private readonly sharedService: SharedService,
    private readonly entityService: EntityService,
    private readonly bankingService: BankingService,
  ) {


    this.loggedinUser = this.authService.user;
    this.url$ = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url));
    this.url$.subscribe((resp) => { this.currentURL = resp; });
  }

  ngOnInit(): void {
    // * Enable lead admin module for specifc user
    const loggedinUser = this.authService.user;
    if (Array.isArray(this.appGlobals.leadAdminModuleAccessUser) && this.appGlobals.leadAdminModuleAccessUser.includes(loggedinUser.email)) {
      this.isLeadAdminModuleAccess = true;
    }


    // check if can show beneficiary module
    this.sharedService.currentKYCStatus.subscribe((response) => {
      this.currentKYCStatus = response;
      if (response && response == this.appGlobals.KYC_STATUSES.APPROVED) {
        this.canShowBeneficiary = true;
      } else {
        this.canShowBeneficiary = false;
      }
    });

    const loggedInUser = this.authService.user;
    if (Array.isArray(this.appGlobals.leadAdminModuleAccessUser) && this.appGlobals.leadAdminModuleAccessUser.includes(loggedInUser.email)) {
      this.isLeadAdminModuleAccess = true;
    }

    this.checkForIntegrationFlags();

    this.sideBarSection = new SideBarSection(this.authService, this.appGlobals);

    this.pageMetaService.activeMenu.subscribe((response: any) => {
      if (response) {
        if (response.name?.toString().toLowerCase() == 'banking' || response.menu?.name?.toString().toLowerCase() == 'banking') {
          this.filterSubMenuIfNoKYC(response);
        }
        if (!response.isReloaded) {
          this.menu = response;
          this.checkForIntegrationFlags();

          if (this.menu?.subMenus?.[0]?.path) {
            this.router.navigate([this.menu?.subMenus[0]?.path]);
          }
        } else if (response.isReloaded) {
          this.menu = response.menu;
          this.checkForIntegrationFlags();
        }
      }
    });

    this.entityService.currentCompanySelection$.subscribe((response) => {
      if (response?.length) {
        if (this.authService.user?.isOwner && !this.authService.user?.isAdmin) {
          if (this.authService.user?.isSecondaryOwner && this.authService.user?.userAccessList.includes('Payments')) {
            this.getKYC();
          } else if (this.authService.user?.isOwner && !this.authService.user?.isSecondaryOwner) {
            this.getKYC();
          }
        }
      }
    })
  }

  getKYC() {
    this.bankingService.getKYC().subscribe((response: any) => {
      if (response && Object.keys(response).length) {
        this.sharedService.updateKYCStatus(response.kycStatus);
      } else {
        this.sharedService.updateKYCStatus(null);
      }
      this.checkForIntegrationFlags();
    });
  }

  checkForIntegrationFlags() {
    if (this.authService.user?.isOwner || this.authService.user?.isOutlet) {
      this.voucherService.getCompanyList().subscribe(res => {
        if (res.length) {
          res.forEach(company => {
            if (company.restaurantSyncCode && company.restaurantSyncCode !== '') {
              if (this.authService.user.isSecondaryOwner) {
                if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_POS)) {
                  this.showPushToPetpooja = true;
                } else {
                  this.showPushToPetpooja = false;
                }
              } else {
                this.showPushToPetpooja = true;
              }
            }

            if (company.retailPosSyncCode && company.retailPosSyncCode !== '') {
              if (this.authService.user.isSecondaryOwner) {
                if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_INVOICE)) {
                  this.showPushToRetailPos = true;
                } else {
                  this.showPushToRetailPos = false;
                }
              } else {
                this.showPushToRetailPos = true;
              }
            }

            if (company.tallySyncCode && company.tallySyncCode !== '') {
              if (this.authService.user.isSecondaryOwner) {
                if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PUSH_TO_TALLY)) {
                  this.showPushToTally = true;
                } else {
                  this.showPushToTally = false;
                }
              } else {
                this.showPushToTally = true;
              }
            }
          });
          this.filterMenus();
        }
      }, (error) => {
      })
    } else {
      this.showPushToPetpooja = true;
      this.showPushToRetailPos = true;
      this.showPushToTally = true;
    }
  }

  filterMenus() {
    const roleAndIsPaidObject = {
      isAdmin: this.authService.user?.isAdmin,
      isLeadAdmin: this.authService.user?.isLeadAdmin,
      isOwner: this.authService.user?.isOwner,
      isPaidUser: this.authService.user.isPaidUser
    }

    this.userRoles = {
      isAdmin: roleAndIsPaidObject.isAdmin, isLeadAdmin: roleAndIsPaidObject.isLeadAdmin,
      isOwner: roleAndIsPaidObject.isOwner, isPaidUser: roleAndIsPaidObject.isPaidUser
    };

    const pushToAndBeneficiaryToggles = {
      showPushToPetpooja: this.showPushToPetpooja,
      showPushToRetailPos: this.showPushToRetailPos,
      showPushToTally: this.showPushToTally,
      showBeneficiary: this.canShowBeneficiary
    }

    this.featureToggles = {
      showPushToPetpooja: pushToAndBeneficiaryToggles.showPushToPetpooja, showPushToRetailPos: pushToAndBeneficiaryToggles.showPushToRetailPos,
      showPushToTally: pushToAndBeneficiaryToggles.showPushToTally, showBeneficiary: pushToAndBeneficiaryToggles.showBeneficiary
    };

    let sections: any;
    if (this.menu.name?.toLowerCase() == 'settings') {
      sections = _.cloneDeep(this.appGlobals.innerSidebarSections);
    } else {
      sections = _.cloneDeep(this.sideBarSection.allSideBarSections);
    }
    if (sections.length) {
      this.menu.subMenus = this.findSubMenusFromMenu(sections, this.menu?.menu ? this.menu?.menu : this.menu);
    }

    if (this.menu.name?.toLowerCase() == 'settings') {
      this.menu.subMenus = this.menu.subMenus?.filter(
        sub => this.sideBarSection.hasAccess(this.userRoles, sub.roles) && this.sideBarSection.hasSecondaryOwnerAccess(sub) &&
          this.sideBarSection.canSecondaryOwnerAccess(sub) &&
          this.sideBarSection.hasUserManagementAccess(sub) && this.sideBarSection.hasDemoAccess(sub) && this.sideBarSection.hasPaidAccess(this.userRoles, sub)
      ) || []
    } else {
      this.menu.subMenus = this.menu.subMenus?.filter(
        sub => this.sideBarSection.hasAccess(this.userRoles, sub.roles) && this.sideBarSection.hasPaidAccess(this.userRoles, sub) &&
          this.sideBarSection.hasFeatureAccess(this.featureToggles, sub) && this.sideBarSection.hasLeadAdminModuleAccess(this.isLeadAdminModuleAccess, this.menu) &&
          this.sideBarSection.canSecondaryOwnerAccess(this.menu)
      );
      if (this.menu.name?.toString().toLowerCase() == 'banking') {
        this.filterSubMenuIfNoKYC(this.menu);
      }
    }

  }

  findSubMenusFromMenu(sections, menuParam) {
    for (const section of sections) {
      if (!section.menus) continue;

      for (const menu of section.menus) {
        // match exact or case-insensitive name
        if (menu.name?.toLowerCase() === menuParam.name.toLowerCase()) {
          return menu.subMenus || [];
        }
      }
    }
    return []; // if not found
  }

  canShowUserManagement(user) {
    if (user.isSecondaryOwner && user.secondaryOwnerRole === 'Employee') {
      return false
    }

    return true;
  }

  /**
   * This method will remove account sub menu from menu if kyc is not done
   * @param response 
   */
  filterSubMenuIfNoKYC(response) {
    if (this.currentKYCStatus && this.currentKYCStatus.toString().toLowerCase() == 'approved') {
      this.menu = response;
    } else if (response.subMenus?.length) {
      response.subMenus = response.subMenus.filter((subMenu) => subMenu.name.toString().toLowerCase() != "account");
      this.menu = response;
    }

  }
}